IREP.focusgroup = (function () {
    var focusGroupId;
    var init = function (initOptions) {
        focusGroupId = initOptions.focusGroupId;
    }

    $(".Answer").on("click", function () {
        $(this).siblings().removeClass('selected');
        $(this).toggleClass('selected');
        return false;
    });

    var validateAnswers = function () {
        switch (focusGroupId) {
            case "3":
                return true;
            case "4":
                if ($("#question1").val().trim() != "" && $("#question2").val().trim() != "" && $("#question3").val().trim() != "") {
                    return true;
                }
                $(".error").show();
                return false;
            case "5":
                if (typeof ($("input[type='radio'][name='question1']:checked").val()) != "undefined" && typeof ($("input[type='radio'][name='question2']:checked").val()) != "undefined" && 
                    $("#question3").val().trim() != "" && $("#question4").val().trim() != "") {
                    return true;
                }
                $(".error").show();
                return false;
            case "6":
                if ($("#question2").val().trim() != "" && $("#question3").val().trim() != "") {
                    var count = 0;
                    $(".checkBox").each(function () {
                        if ($(this).hasClass('selected')){
                            count++;
                        }
                    })
                    if (count > 0)
                        return true;
                    else {
                        $(".error").show();
                        return false;
                    }
                }
                else {
                    $(".error").show();
                    return false;
                }
            case "7":
                if ($("#question2").val().trim() != "" && $("#question3").val().trim() != "") {
                    var count = 0;
                    $(".checkBox").each(function () {
                        if ($(this).hasClass('selected')) {
                            count++;
                        }
                    })
                    if (count > 0)
                        return true;
                    else {
                        $(".error").show();
                        return false;
                    }
                }
                else {
                    $(".error").show();
                    return false;
                }
            default:
                if ($(".selected").size() != 5) {
                    $(".error").show();

                    return false;
                } else {
                    if ($("#questionSix").val().trim() != "") {
                        return true;
                    }
                    else {
                        $(".error").show();
                    }

                }
        }
        return false;
    }

    $("#SubmitButton").on("click", function () {
        if (validateAnswers()) {
            var results = [];
            switch (focusGroupId) {
                case "3":
                    break;
                case "4":
                    results.push({ questionId: $("#question1").attr('data-questionId'), answerId: $("#question1").attr('data-answerId'), text: $("#question1").val().trim() });
                    results.push({ questionId: $("#question2").attr('data-questionId'), answerId: $("#question2").attr('data-answerId'), text: $("#question2").val().trim() });
                    results.push({ questionId: $("#question3").attr('data-questionId'), answerId: $("#question3").attr('data-answerId'), text: $("#question3").val().trim() });
                    break;
                case "5":
                    results.push({ questionId: $("input[type='radio'][name='question1']").attr('data-questionId'), answerId: $("input[type='radio'][name='question1']:checked").val() });
                    results.push({ questionId: $("input[type='radio'][name='question2']").attr('data-questionId'), answerId: $("input[type='radio'][name='question2']:checked").val() });
                    results.push({ questionId: $("#question3").attr('data-questionId'), answerId: $("#question3").attr('data-answerId'), text: $("#question3").val() });
                    results.push({ questionId: $("#question4").attr('data-questionId'), answerId: $("#question4").attr('data-answerId'), text: $("#question4").val() });
                    break;
                case "6":
                    $(".checkBox").each(function () {
                        if ($(this).hasClass('selected')) {
                            results.push({ questionId: $(this).attr('data-questionId'), answerId: $(this).attr('data-answerId') })
                        }
                    })

                    results.push({ questionId: $("#question2").attr('data-questionId'), answerId: $("#question2").attr('data-answerId'), text: $("#question2").val().trim() });
                    results.push({ questionId: $("#question3").attr('data-questionId'), answerId: $("#question3").attr('data-answerId'), text: $("#question3").val().trim() });
                    break;
                case "7":
                    $(".checkBox").each(function () {
                        if ($(this).hasClass('selected')) {
                            results.push({ questionId: $(this).attr('data-questionId'), answerId: $(this).attr('data-answerId') })
                        }
                    })

                    results.push({ questionId: $("#question2").attr('data-questionId'), answerId: $("#question2").attr('data-answerId'), text: $("#question2").val().trim() });
                    results.push({ questionId: $("#question3").attr('data-questionId'), answerId: $("#question3").attr('data-answerId'), text: $("#question3").val().trim() });
                    break;
                default:
                    $(".selected").each(function () {
                        results.push({ questionId: $(this).attr('data-questionId'), answerId: $(this).attr('id') });
                    });
                    results.push({ questionId: $("#questionSix").attr('data-questionId'), answerId: $("#questionSix").attr('data-answerId'), text: $("#questionSix").val() });
                    break;

            }
            var data = {
                focusGroupId: focusGroupId,
                quizData: {
                    activityUID: $(this).attr('data-activityUID'),
                    results: results
                }
            };
            //console.log(data);
            IREP.callApi({ url: "/promotion/FocusGroup/Submit", data: data, type: "POST" }).done(function (data) {
                $("#submitButtonDiv").css("display", "none");
                window.location.reload(true);
            });

        }
        return false;
    });

    //focus group 6
    $(".checkBox").on("click", function () {
        //$(this).attr('id')
        if ($(this).hasClass('selected')){
            $(this).removeClass('selected');
        } else {
            $(this).addClass('selected');
        }
    });

    return {
        init: init
    };
})();